<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="warning"
    :width="500"
    @close="onClose"
  >
    <h3 class="status-dialog__title">申请作废</h3>
    <p class="status-dialog__desc">
      确定要申请作废该发票吗？提交后将进入审核，审核通过前发票仍可下载。
    </p>
    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn status-dialog__btn--primary"
        :disabled="loading"
        @click="onConfirm"
      >
        确定申请
      </button>
    </div>
  </StatusDialog>
</template>

<script>
export default {
  name: 'RequestCancelDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  methods: {
    onClose() {
      if (this.loading) return;
      this.$emit('close');
    },
    onConfirm() {
      if (this.loading) return;
      this.$emit('confirm');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/InvoiceCenter/RequestCancelDialog.vue